/**
 * What tapping something in a widget does: send a backend button, or say words — the same two ways
 * the user has (voice and touch are equivalent). Shared by every widget's props schema.
 */
import { z } from 'zod';
import type { WidgetApi } from './contract';

export const intentSchema = z.union([
  z.object({ press: z.object({ button: z.string(), data: z.record(z.string(), z.unknown()).default({}) }) }),
  z.object({ say: z.string().min(1) }),
]);
export type Intent = z.infer<typeof intentSchema>;

export function run(api: WidgetApi, intent: Intent): void {
  if (api.readOnly) return;
  if ('press' in intent) api.press(intent.press.button, intent.press.data);
  else api.say(intent.say);
}
